<template>
  <div class="vp-detection-details">
    <n-card :style="cardStyle">
      <div class="status" v-if="attachment">
        <img :src="imgs.link" :width="calc(120)" />
        <span :style="{ marginTop: calc(26), fontSize: calc(32) }">显微附件已连接</span>
      </div>
      <div class="alarm" v-if="msg">
        <span :style="{ fontSize: this.calc(40) }">
          {{ alarm.name }}
        </span>
        <div class="alarm-icons" :style="{ margin: `${this.calc(26)} 0` }">
          <img
            :style="iconStyle"
            v-for="src in alarm.imgs"
            :key="src"
            :src="`/static/image/GHS/${src}.png`"
          />
        </div>
        <!-- <div>
          <img
            class="report"
            :src="imgs.report"
            :width="calc(240)"
            :height="calc(65)"
            @click="report"
          />
        </div> -->
      </div>
    </n-card>
  </div>
</template>

<script>
import NCard from '@/components/virtualPhone/components/NCard';
import { assets } from '@/components/virtualPhone/utils';

export default {
  components: {
    NCard
  },
  inject: ['calc'],
  props: {
    msg: {
      type: [Object, null],
      default: null
    },
    attachment: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      flag: 'status',
      imgs: {
        link: assets({ icon: 'link', dir: '/detect' }),
        report: assets({ icon: 'detect-report', dir: '/detect' })
      },
      alarm: {
        name: '',
        imgs: ''
      }
    };
  },
  computed: {
    iconStyle() {
      const v = this.calc(134);
      return {
        width: v,
        height: v
      };
    },
    cardStyle() {
      const { calc } = this;
      return {
        width: calc(640),
        padding: `1px ${calc(45)}`,
        height: calc(420)
      };
    }
  },
  methods: {
    report() {
      this.$emit('report');
    }
  },
  watch: {
    msg(n) {
      if (!n) return;
      this.alarm.name = n.materialName || '未知物质';
      this.alarm.imgs = n.imgs ? n.imgs.split(',') : ['GHS10'];
    }
  }
};
</script>

<style lang="scss" scoped>
.vp-detection-details {
  height: 100%;
  .alarm,
  .status {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .report {
    cursor: pointer;
  }
}
</style>
